export default __webpack_public_path__ + "static/media/a.9d866974.png";